module.exports = __webpack_public_path__ + "./favicons/android-icon-72x72.png";